import React from 'react';
import { twMerge } from 'tailwind-merge';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
  id?: string;
  noPadding?: boolean;
  fullWidth?: boolean;
}

export default function Section({
  children,
  className,
  dark = false,
  id,
  noPadding = false,
  fullWidth = false,
}: SectionProps) {
  return (
    <section
      id={id}
      className={twMerge(
        'relative overflow-hidden',
        dark ? 'bg-dark text-white' : 'bg-surface text-text-dark',
        !noPadding && 'section-padding',
        className
      )}
    >
      <div className={twMerge(!fullWidth && 'max-container', 'relative z-10')}>
        {children}
      </div>
    </section>
  );
}
